/**
 * @prettier
 */
export const UruguayanTaxes = {
    IVA_TASA_BASICA: 'IVA_TASA_BASICA',
    IVA_TASA_MINIMA: 'IVA_TASA_MINIMA',
} as const;

export type UruguayanTax = typeof UruguayanTaxes[keyof typeof UruguayanTaxes];
